<script setup>
import { useI18n } from 'vue-i18n';
import SalesDetailNucleoRequest from './SalesDetailNucleoRequest.vue';

defineProps({
  requests: { type: Array, default: () => [] },
  showOpenAction: { type: Boolean, default: true },
});
const { t } = useI18n();
</script>

<template>
  <div
    v-if="!requests.length"
    class="rounded-lais border border-dashed border-lais-border bg-white p-8 text-center text-sm text-lais-text-muted"
  >
    {{ t('SALES.DETAIL.NUCLEO.EMPTY') }}
  </div>
  <div v-else class="grid gap-6">
    <h2
      class="font-redHatDisplay text-lais-heading-lg font-semibold text-lais-text"
    >
      {{ t('SALES.DETAIL.NUCLEO.TITLE') }}
    </h2>
    <SalesDetailNucleoRequest
      v-for="request in requests"
      :key="request.group_key"
      :request="request"
      :show-open-action="showOpenAction"
    />
  </div>
</template>
